<template>
  <div>
    <div
      v-if="open"
      class="dwp-absolute dwp-inset-0 dwp-bg-gray-400 dwp-opacity-75 dwp-z-40"
      @click="open = false"
    ></div>
    <div
      class="dwp-overflow-hidden dwp-rounded dwp-absolute dwp-z-40 dwp-h-full"
      style="max-width: 295px"
    >
      <transition
        enter-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
        enter-class="dwp--translate-x-full"
        enter-to-class="dwp-translate-x-0"
        leave-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
        leave-class="dwp-translate-x-0"
        leave-to-class="dwp--translate-x-full"
      >
        <div
          v-if="open"
          class="dwp-h-full dwp-flex-1 dwp-flex dwp-flex-col dwp-w-full dwp-bg-white dwp-shadow-lg dwp-border-r dwp-border-gray-300"
        >
          <!-- <div class="dwp-absolute dwp-top-0 dwp-right-0 dwp--mr-14 dwp-p-1">
            <button
              class="dwp-flex dwp-items-center dwp-justify-center dwp-h-12 dwp-w-12 dwp-rounded-full focus:dwp-outline-none focus:dwp-bg-gray-200"
              aria-label="Close sidebar"
            >
              <ArrowLeftIcon @click="open = false" class="dwp-h-6 dwp-w-6 dwp-text-gray-500" />
            </button>
          </div>-->
          <div class="dwp-flex-1 dwp-h-0 dwp-overflow-y-auto">
            <div class="dwp-px-8 dwp-mt-6 dwp-flex dwp-items-center">
              <span class="dwp-relative dwp-z-0 dwp-inline-flex dwp-shadow-sm dwp-rounded-md">
                <button
                  @click.prevent="addNew"
                  type="button"
                  class="dwp-relative dwp-inline-flex dwp-whitespace-no-wrap dwp-items-center dwp-px-4 dwp-py-2 dwp-rounded-l-md dwp-border dwp-border-primary dwp-bg-primary dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-white hover:dwp-text-primary-200 focus:dwp-z-10 focus:dwp-outline-none focus:dwp-border-blue-300 focus:dwp-shadow-outline-blue active:dwp-bg-gray-100 active:dwp-text-gray-700 dwp-transition dwp-ease-in-out dwp-duration-150"
                >
                  <PlusIcon class="dwp-w-3 dwp-mr-1" stroke-width="3" />New List
                </button>
                <button
                  @click.prevent="importModal = true"
                  type="button"
                  class="dwp--ml-px dwp-relative dwp-whitespace-no-wrap dwp-inline-flex dwp-items-center dwp-px-4 dwp-py-2 dwp-rounded-r-md dwp-border dwp-border-gray-300 dwp-bg-white dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-gray-700 hover:dwp-text-gray-500 focus:dwp-z-10 focus:dwp-outline-none focus:dwp-border-blue-300 focus:dwp-shadow-outline-blue active:dwp-bg-gray-100 active:dwp-text-gray-700 dwp-transition dwp-ease-in-out dwp-duration-150"
                >
                  <DownloadCloudIcon class="dwp-w-3 dwp-mr-1 dwp-opacity-75" stroke-width="3" />Import List
                </button>
              </span>
            </div>
            <div class="dwp-px-8 dwp-mt-4">
              <!-- <div
                class="dwp-text-sm dwp-text-gray-500 dwp-mb-2 dwp-truncate"
              >{{ currentList.title }}</div>-->
              <!-- <a
                href="#"
                class="group dwp-flex dwp-items-center dwp-px-3 dwp--mx-2 dwp-py-2 dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-gray-700 dwp-rounded-md hover:dwp-text-gray-900 hover:dwp-bg-gray-100 focus:dwp-outline-none focus:dwp-bg-gray-200 dwp-transition dwp-ease-in-out dwp-duration-150"
                aria-current="page"
              >
                <EditIcon
                  class="dwp-flex-shrink-0 dwp--ml-1 dwp-mr-3 dwp-h-4 dwp-w-4 dwp-text-gray-500 group-hover:dwp-text-gray-500 group-focus:dwp-text-gray-600 dwp-transition dwp-ease-in-out dwp-duration-150"
                />
                <span class="dwp-truncate">Edit List</span>
              </a>-->

              <!-- <a
                href="#"
                class="group dwp-flex dwp-items-center dwp-px-3 dwp--mx-2 dwp-py-2 dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-gray-700 dwp-rounded-md hover:dwp-text-gray-900 hover:dwp-bg-gray-100 focus:dwp-outline-none focus:dwp-bg-gray-200 dwp-transition dwp-ease-in-out dwp-duration-150"
                aria-current="page"
              >
                <TrashIcon
                  class="dwp-flex-shrink-0 dwp--ml-1 dwp-mr-3 dwp-h-4 dwp-w-4 dwp-text-gray-500 group-hover:dwp-text-gray-500 group-focus:dwp-text-gray-600 dwp-transition dwp-ease-in-out dwp-duration-150"
                />
                <span class="dwp-truncate">Trash List</span>
              </a>-->
            </div>

            <!-- <div
            class="dwp-px-8 dwp-text-sm dwp-text-gray-500 dwp-mb-2 dwp-mt-8 dwp-truncate"
          >{{ currentList.title }}
            </div>-->
            <div class="dwp-mt-5 dwp-border-t dwp-border-gray-300 dwp-py-4">
              <div class="dwp-px-8 dwp-text-sm dwp-text-gray-500 dwp-mb-2">{{ projectName }} Lists</div>
              <!-- <div
                class="dwp-pl-8 dwp-pr-6 dwp-py-2 dwp-text-sm dwp-truncate dwp-cursor-pointer dwp-rounded-r-full dwp-mr-6 dwp-bg-gray-200"
                @click.prevent="open = false;"
              >
                <span
                  class="dwp-flex-shrink dwp-flex dwp-items-center dwp-space-x-2 dwp-truncate dwp-text-gray-800"
                >
                  <ProgressBadge
                    :percentage="percentage(currentList)"
                    class="dwp-rounded-full dwp-w-4 dwp-h-4 dwp-duration-500 dwp-flex-shrink-0"
                    :class="percentage(currentList) == 100 ? 'dwp-text-green-500 dwp-border-green-500' : 'dwp-text-primary dwp-border-primary'"
                    style="border-width: 1.5px; padding: 2px; transition-property:border-color"
                  />
                  <div class="dwp-flex-1 dwp-truncate">{{ currentList.title }}</div>
                </span>
              </div>-->
              <template v-for="item in lists">
                <div
                  :class="item.id == currentList.id ? 'dwp-bg-gray-200' : 'dwp-bg-white-200'"
                  class="dwp-px-8 dwp-py-2 dwp-text-sm dwp-truncate dwp-cursor-pointer dwp-rounded-r-full dwp-mr-6"
                  @click.prevent="currentList = item; open = false;"
                  :key="item.id"
                >
                  <span
                    class="dwp-flex-shrink dwp-flex dwp-items-center dwp-space-x-2 dwp-truncate dwp-text-gray-800"
                  >
                    <ProgressBadge
                      :percentage="percentage(item)"
                      class="dwp-rounded-full dwp-w-4 dwp-h-4 dwp-duration-500 dwp-flex-shrink-0"
                      :class="percentage(item) == 100 ? 'dwp-text-green-500 dwp-border-green-500' : 'dwp-text-primary dwp-border-primary'"
                      style="border-width: 1.5px; padding: 2px; transition-property:border-color"
                    />
                    <div class="dwp-flex-1 dwp-truncate">{{ item.title }}</div>
                  </span>
                </div>
              </template>
            </div>
          </div>
          <div
            class="dwp-flex-shrink-0 dwp-flex dwp-items-center dwp-px-8 dwp-py-4 dwp-border-t dwp-border-gray-300"
          >
            <a
              @click.prevent="signOut"
              class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
              role="menuitem"
            >
              <LogOutIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
              <div>Sign Out</div>
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import {
  PlusIcon,
  ArrowLeftIcon,
  UploadCloudIcon,
  LogOutIcon,
  DownloadCloudIcon,
  EditIcon,
  TrashIcon,
} from "vue-feather-icons";
import ProgressBadge from "@/components/ui/ProgressBadge.vue";

import { sync, call } from "vuex-pathify";
import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],
  components: {
    PlusIcon,
    DownloadCloudIcon,
    EditIcon,
    ProgressBadge,
    LogOutIcon,
    UploadCloudIcon,
    ArrowLeftIcon,
    TrashIcon,
    VButton,
  },
  computed: {
    open: sync("ui/slideMenu"),
    newModal: sync("ui/modal@list.new.open"),
    importModal: sync("ui/modal@list.import.open"),
    projectName() {
      return docketData?.sitename || "This Project's";
    },
  },
  methods: {
    ...call("user", ["signOut"]),
    addNew() {
      this.newModal = true;
    },
    percentage(list) {
      if (!list?.counts?.total || !list?.counts?.done) {
        return 0;
      }
      return (list.counts.done / list.counts.total) * 100;
    },
  },
};
</script>